import {Box, Stack, alpha, styled} from '@mui/material';

interface NumberNotificationProps {
	$isNotificationsEnabled?: boolean;
}

export const StackContainer = styled(Stack)`
	background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.12)};
	border-radius: 8px;
	padding: 4px;
	display: flex;
	align-items: center;
`;

export const Notifications = styled(Box)<NumberNotificationProps>`
	min-width: 17px;
	padding: 0 3px;
	height: 17px;
	border-radius: 50%;
	font-size: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
	color: ${({theme, $isNotificationsEnabled}) =>
		$isNotificationsEnabled ? theme.palette.text.primary : theme.palette.text.disabled};
	background-color: ${({theme, $isNotificationsEnabled}) =>
		$isNotificationsEnabled ? theme.palette.warning.light : theme.palette.grey[300]};
`;
